<template>
  <div>
    <el-table
      :data="resultList"
      style="width: 100%"
      :header-cell-class-name="handleCellclass"
      :cell-class-name="handleCellclass"
    >
      <el-table-column prop="title" label="" width="100">
        <template slot-scope="scope">
          <span>{{ identifyResultList[scope.$index].title }}</span>
        </template>
      </el-table-column>
      <el-table-column type="index"> </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { connectionessay_list } from "@/utils/owner";
export default {
  data() {
    return {
      datalist: [],
      tableData: [
        {
          batchNo: "2020102801",
          createDate: "2020-10-28 19:21:56",
          id: 5062,
          aaa: "asdsd",
          bbb: "2432",
          ccc: "aaaawewewqccc"
        },
        {
          batchNo: "2020102801",
          createDate: "2020-10-28 19:21:56",
          id: 5062,
          aaa: "asdsd",
          bbb: "2432",
          ccc: "aaaawewewqccc"
        }
      ],
      resultList: [
        { title: "批次号", label: "batchNo" },
        { title: "id", label: "id" },
        { title: "aaa", label: "aaa" },
        { title: "bbb", label: "bbb" },
        { title: "ccc", label: "ccc" },
        { title: "时间", label: "createDate" }
      ]
    };
  },
  created() {
    this.ownerId = JSON.parse(localStorage.getItem("userInfo")).id;
    console.log("用户id", this.ownerId);
    this.getBookList();
  },
  methods: {
    // 获取书籍列表
    getBookList() {
      var that = this;
      let obj = {
        departmentuser_id: that.ownerId
      };
      connectionessay_list(obj).then(res => {
        if (res.data.code == 1) {
          that.datalist = res.data.data;
          console.log("datalist", that.datalist);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    handleCellclass({ column, columnIndex }) {
      if (columnIndex !== 0 && column.label.indexOf("识别结果") !== -1) {
        return "tableColumnClass";
      } else {
        return "";
      }
    }
  }
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/view/owner/Cooperation.vue